import { WHY_POINTS } from "../data/content";
import { useReveal } from "../hooks/useReveal";

const WhySamora = () => {
    const ref = useReveal();
    return (
        <section
            ref={ref}
            data-testid="why-section"
            className="py-24 md:py-40 bg-samora-ink text-samora-bone"
        >
            <div className="max-w-[1440px] mx-auto px-6 md:px-12">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 mb-16 md:mb-24 items-end">
                    <div className="lg:col-span-6 reveal">
                        <p className="eyebrow text-samora-gold mb-6">
                            Why Samora Spaces
                        </p>
                        <h2
                            className="font-display leading-[0.95] tracking-tight text-samora-bone"
                            style={{ fontSize: "clamp(2.5rem, 6vw, 5.5rem)" }}
                        >
                            The reasons families<br />
                            <span className="italic font-serif text-samora-gold">
                                come back a second time.
                            </span>
                        </h2>
                    </div>
                    <p className="lg:col-span-5 lg:col-start-8 text-samora-bone/75 text-base md:text-lg leading-relaxed reveal">
                        Interior design in India is a crowded room. We keep our
                        promises so quietly that our clients tell everyone
                        else.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-12 lg:gap-x-20 gap-y-16">
                    {WHY_POINTS.map((w) => (
                        <div
                            key={w.n}
                            data-testid={`why-point-${w.n}`}
                            className="reveal border-t border-samora-bone/20 pt-6"
                        >
                            <span className="font-serif text-samora-gold text-lg">
                                — {w.n}
                            </span>
                            <h3 className="font-display text-3xl md:text-4xl mt-3">
                                {w.t}
                            </h3>
                            <p className="mt-4 text-samora-bone/70 text-sm md:text-base leading-relaxed">
                                {w.d}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default WhySamora;
